import { createTranslations } from '@npco/utils-translations'

export const accountEditModalTranslations = createTranslations({
  title: 'Edit Account',
  actionSave: 'Save',
  actionCancel: 'Cancel',
  toastSaveSuccess: 'Account changes saved.',
  toastSaveError: 'Failed to save changes.',
})
